export interface VehicleTpmsDto {
  frontRightWheelPressure?: number;
  frontRightWheelTemperature?: number;
  rearRightWheelPressure?: number;
  rearRightWheelTemperature?: number;
  frontLeftWheelPressure?: number;
  frontLeftWheelTemperature?: number;
  rearLeftWheelPressure?: number;
  rearLeftWheelTemperature?: number;
  staleTpmsIndicator?: number;
}
